import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ContentService {

  pages: Object = {

    'dropbox': {
      title: 'Dropbox', 
      attb: 'Animation, Editing', 
      info: 'Video animations for Dropbox website and social channels.', 
      imageURL: 'assets/work/brand-bkgd/hellosign-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/hellosign_thumb.png',
    },

    'hellosign': {
      title: 'Hellosign', 
      attb: 'Animation', 
      info: 'Video animations for Hellosign customers and social channels.', 
      imageURL: 'assets/work/brand-bkgd/hellosign-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/hellosign_thumb.png',
    },

    'lastpass': {
      title: 'LastPass', 
      attb: 'Animation, Editing', 
      info: 'Video animations for social channels.', 
      imageURL: 'assets/work/brand-bkgd/lastpass-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/lastpass_thumb.png',
    },

    'snap': {
      title: 'Snapchat', 
      attb: 'Animation, Editing', 
      info: 'Video animation for B to B', 
      imageURL: 'assets/work/brand-bkgd/snap-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/snap_thumb.png',
    },
    
    'turbotax': {
      title: 'TurboTax', 
      attb: 'Animation, Editing', 
      info: 'Video animations for social and App Stores.', 
      imageURL: 'assets/work/brand-bkgd/turbotax-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/turbotax_thumb.png',
    },

    'jitb': {
      title: 'Jack In The Box', 
      attb: 'Animations', 
      info: 'Animations for Snapchat, TikTok, and App Stores.', 
      imageURL: 'assets/work/brand-bkgd/jitb-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/jitb_thumb.png',
    },
    
    'blueland': {
      title: 'Blueland Cleaning Supplies', 
      attb: 'Animations • Color Grading', 
      info: 'Social spots focused on showcsing product.', 
      imageURL: 'assets/work/brand-bkgd/blueland-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/blueland_thumb.png',
    },

    'lively': {
      title: 'Lively Hearing Aids', 
      attb: 'Video Editing • Animations • Gfx • Color Grading', 
      info: 'Worked on series of commercials ranging from testimonials to product focused spots.', 
      imageURL: 'assets/work/brand-bkgd/lively-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/lively_thumb.png',
    },

    'experian': {
      title: 'Experian', 
      attb: 'Video • Animations', 
      info: 'Animations for social channels.', 
      imageURL: 'assets/work/brand-bkgd/experian-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/experian_thumb.png',
    },

    'mint': {
      title: 'Mint', 
      attb: 'Video • Animations', 
      info: 'Animations for social channels.', 
      imageURL: 'assets/work/brand-bkgd/mint-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/mint_thumb.png',
    },

    'dla-code': {
      title: 'Los Angeles Tourism', 
      attb: 'Web Development', 
      info: 'Worked on frontend dev and design on Discoverlosangeles.com. Drupal 8, patternlab and sketch. Created parallax/over scroll ads on homepage for dektop and mobile. Coded html5 vanilla javascript banners for brand and sales.', 
      imageURL: 'assets/work/brand-bkgd/dla-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/dla_thumb.png',
    },

    'dla-video': {
      title: 'Los Angeles Tourism', 
      attb: 'Video • Animations', 
      info: 'Work on videos and animations to promote LA Tourism locally and abroad.', 
      imageURL: 'assets/work/brand-bkgd/dla-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/dla_thumb.png',
    },

    'dla-design': {
      title: 'Los Angeles Tourism', 
      attb: 'Retouching • OOH ', 
      info: 'Retouching and OOH for LA Tourism brand.', 
      imageURL: 'assets/work/brand-bkgd/dla-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/dla_thumb.png',
    },

    'dinela': {
      title: 'dine L.A.',
      attb: 'Editing • Animation • Retouching',
      info: 'Videos promoting DineL.A.',
      imageURL: 'assets/work/brand-bkgd/dinela-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/dinela_thumb.png',
    },

    'att': {
      title: 'Loveloud Festival', 
      attb: 'Editing • Grading • Animations', 
      info: 'Video editing, color grading, motion graphics, gfx and retouching. All for At&t and the Loveloud Festival.', 
      imageURL: 'assets/work/brand-bkgd/att-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/att_thumb.png',
    },

    'e': {
      title: 'Keeping up with the Kardashians • I am Cait',
      attb: 'Art Direction • Editing • Animations',
      info: 'Led design and established look and feel of social content for E! Network’s top tier reality TV shows. ',
      imageURL: 'assets/work/brand-bkgd/e!-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/e!_thumb.png',
    },

    'tnt-video': {
      title: 'Good Behavior', 
      attb: 'Art Direction • Animations • Editing', 
      info: 'Executed both animation and video edits for episodic recaps, special promotions, and more.', 
      imageURL: 'assets/work/brand-bkgd/tnt-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/tnt_thumb.png',
    },

    'tnt-design': {
      title: 'Good Behavior', 
      attb: 'Art Direction • Animations • Editing', 
      info: 'Led design and branding for social channels across Facebook, Instagram, and Twitter. Art directed photo shoots for custom countdown content.', 
      imageURL: 'assets/work/brand-bkgd/tnt-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/tnt_thumb.png',
    },

    'tbs': {
      title: 'Angie Tribeca • The Detour • Wrecked • People of Earth • Search Party',
      attb: 'Design Director',
      info: 'Oversaw team of designers and copywriters for all social content across major platforms (Facebook, Instagram, Twitter, Snapchat), while rolling up my sleeves when needed.',
      imageURL: 'assets/work/brand-bkgd/tbs-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/tbs_thumb.png',
    },

    'mv': {
      title: 'Madison + Vine', 
      attb: 'Wordpress Develpment', 
      info: "Brought Madison + Vine's website to life through wordpress and animation to showcase client work.", 
      imageURL: 'assets/work/brand-bkgd/mv-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/mv_thumb.png',
    },

    'slk': {
      title: 'Summers, Levine & Kretzner', 
      attb: 'Wordpress Develpment', 
      info: 'Designed SLK family law website and developed to look modern and simple.', 
      imageURL: 'assets/work/brand-bkgd/slk-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/slk_thumb.png',
    },

    'lux': {
      title: 'Lux Capta Films', 
      attb: 'Wordpress Develpment • Animation', 
      info: 'Simple clean website for film production company.', 
      imageURL: 'assets/work/brand-bkgd/lux-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/lux_thumb.png',
    },

    'kfp3': {
      title: 'Kung Fu Panda 3', 
      attb: 'Art Direction • Animations', 
      info: 'Lead designer on all social content for the premiere of Kung Fu Panda 3.', 
      imageURL: 'assets/work/brand-bkgd/kfp3-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/kfp3_thumb.png',
    },

    'bl': {
      title: 'Brianna Lohr', 
      attb: 'Wordpress Develpment', 
      info: 'Simple and fun portfolio website development', 
      imageURL: 'assets/work/brand-bkgd/bl-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/bl_thumb.png',
    },

    'anthem': {
      title: 'Blue Cross Blue Sheild', 
      attb: 'Design • Animation', 
      info: 'These were my early days of self-taught coding when Flash was still going strong.', 
      imageURL: 'assets/work/brand-bkgd/anthem-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/anthem_thumb.png',
    },

    'discover': {
      title: 'Discover Card', 
      attb: 'Web Design • Animaiton • Html', 
      info: 'Executed dev-friendly designs on discover.com, as well as rich digital banner ads.', 
      imageURL: 'assets/work/brand-bkgd/discover-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/discover_thumb.png',
    },

    'opi': {
      title: 'OPI',
      attb: 'VIDEO • ANIMATIONS',
      info: 'Freelance work on video, color grading and animations',
      imageURL: 'assets/work/brand-bkgd/opi-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/opi_thumb.png',
    },

    'fj': {
      title: 'Fragant Jewels',
      attb: 'Editing • Color Grading • gfx',
      info: 'Freelance work on video, color grading and gfx',
      imageURL: 'assets/work/brand-bkgd/fj-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/fj_thumb.png',
    },

    'lovely': {
      title: 'Lovely Bride',
      attb: 'Web Design • Email Design • Print',
      info: 'Redesigned lovelybride.com, as well as executed design on weekly emails.',
      imageURL: 'assets/work/brand-bkgd/lovely-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/lovely_thumb.png',
    },
    
    'noosa': {
      title: 'This is no ordinary yoghurt',
      attb: 'Web Design • Print • OOH',
      info: 'Lead designer for out of home mural in Brooklyn, sampling truck, and booths. Lead designer for noosayoghurt.com, launching Q2 of 2017. Execute design across various print assets.',
      imageURL: 'assets/work/brand-bkgd/noosa-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/noosa_thumb.png',
    },

    'mattel': {
      title: 'DC Superhero Girls',
      attb: 'Web Design',
      info: 'Lead designer on the new dcsuperherogirls.com. Designed homepage layout, character pages, product pages, quizzes, and much more throughout the responsive site.',
      imageURL: 'assets/work/brand-bkgd/dcshg-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/dcshg_thumb.png',
    },

    'fox': {
      title: 'Eddie the Eagle',
      attb: 'Design • Animation • Editing',
      info: 'Helped to develop look and feel for film across social. Executed design and animation, as well as light editing.',
      imageURL: 'assets/work/brand-bkgd/ete-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/ete_thumb.png',
    },

    'stx': {
      title: 'The Boy',
      attb: 'Design • Animation • Web Development',
      info: 'Worked closely with STX Entertainment to establish look and feel and develop key art for this horror film. Executed design and animation across social, as well as developed their tumblr site.',
      imageURL: 'assets/work/brand-bkgd/stx-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/stx_thumb.png',
    },

    'toyota-video': {
      title: 'Toyota parts and services',
      attb: 'Video Design • Animation',
      info: 'Led conceptual design, light editing and animation across Facebook and Twitter.',
      imageURL: 'assets/work/brand-bkgd/toyota-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/toyota_thumb.png',
    },

    'toyota-design': {
      title: 'Toyota parts and services',
      attb: 'Design • Animation',
      info: 'Led conceptual design and animation across Facebook and Twitter.',
      imageURL: 'assets/work/brand-bkgd/toyota-bkgd.jpg',
      logoURL: 'assets/work/work-overlay-thumbs/toyota_thumb.png',
    },
  };
  constructor() { }
}
